import {Component, OnInit, OnDestroy, ViewChild} from "@angular/core";
import {ActivatedRoute, Params, Router} from "@angular/router";
import { TableService, VisitedService, DictionaryService } from "@amlCore/services";
import { TableReactiveUrlController } from "@amlCore/tableReactive";
import { CheckTransactionsFilter } from "@amlCore/models";
import {AlertPanelComponent, AlertPanelService} from "@amlCore/components";
import {IDossierPage} from "../../interfaces";
import {ConfirmComponent} from "@amlCore/modals";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {saveAs} from "file-saver";
import {Utils} from "@amlCore/utils";
import {Observable} from "rxjs"
import {CheckTransactionInfo} from "../../models/transaction/checkTransactionInfo.model";
import {IDictItemType} from "@amlCore/interfaces";
import {CheckTransactionsService} from "./checkTransactions.service";
import {CheckTransactionRejectInfo} from "../../models/transaction/checkTransactionRejectInfo.model";
import {CheckTransactionRejectResult} from "../../models/transaction/checkTransactionRejectResult.model";
import {CheckTransactionRejectResultComponent} from "./checkTransactionRejectResult.component";
import {GenerateFesComponent} from "./generateFes";
import {IQrefPrpod5599} from "../../../dictionaries";
import {TransactionSubject} from "../../models";
import {CheckTransactionDayReportComponent} from "./report";
import {CheckDayReportParamsModel} from "../../models/transaction/checkDayReportParamsModel";
import {finalize} from "rxjs/operators";
import {FileSaverService} from "ngx-filesaver";

@Component({
  selector: "app-check-transactions",
  templateUrl: "./checkTransactions.component.html",
  styleUrls: ['./checkTransactions.component.scss']
})

export class CheckTransactionsComponent extends TableReactiveUrlController implements OnInit, OnDestroy, IDossierPage {

  @ViewChild("alertObjSave") alertObjToSave: AlertPanelComponent;

  private readonly MAX_EXPORTS_CHECKS = 1000; // Макс. кол-во выгружаемых результатов проверок
  participantState = [];
  public qrefVo4936: IDictItemType[] = [];
  public list5599u: IQrefPrpod5599[] = [];
  isShowVisited = true;
  loadingExcelFile = false;
  loadingReportFile = false;
  checkTransactionsList: CheckTransactionInfo[] = []; // анализ клиентских операций
  isDossierPart = false; // Признак, что раздел в досье
  idDossier: string; // id досье если isDossierPart === true

  constructor(protected activatedRoute: ActivatedRoute,
              protected router: Router,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected alertPanelSrv: AlertPanelService,
              private dictSrv: DictionaryService,
              private readonly modalService: NgbModal,
              private service: CheckTransactionsService,
              private fSaver: FileSaverService) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'checkDate', dir: 'DESC'});
  }

  ngOnInit(): void {
    this.isDossierPart = this.activatedRoute.snapshot.data.isDossierPart;
    this.idDossier = this.activatedRoute.snapshot.parent.params.id;
    /* если находимся в новом досье которое еще только создается, то список операций не запрашиваем */
    if (this.activatedRoute.routeConfig.data.hasOwnProperty('isDossierPart') && !this.idDossier) {
      this.total = 0;
      return;
    }
    this.activatedRoute.queryParams.subscribe((data: CheckTransactionsFilter) => {
      this._loadList(this.syncParams(data));
    });
    this.dictSrv.getDictionaryData('qrefVo4936').subscribe((result) => {
      this.qrefVo4936 = result;
    });
    this.dictSrv.getDictionaryData('qrefPrpod5599').subscribe((result) => {
      this.list5599u = result;
    });
    // todo тут необходимо пределить получение справочника для статусов участника
    this.dictSrv.getRemoteData('participant_state').then((stateList) => {
      this.participantState = stateList;
    });
    this.createUniqueKeyForStore();
  }

  onPageChange(params: CheckTransactionsFilter): void {
    this.navigate({...params, ...this.getParams(this.filter)});
  }

  onSearch(): void {
    const params = this.getSearchPage(this.filter) as CheckTransactionsFilter;
    this.onPageChange(params);
  }

  private _loadList(params?: CheckTransactionsFilter): void {
    const queryParams = {...this.params, ...this.getParamsv2(params)};
    if (typeof this.storeService.get(this.keyFilterResult) === "boolean") {
      queryParams["result"] = this.storeService.get(this.keyFilterResult);
    }
    if (this.idDossier) {
      this.service.getTransactionCheckList(this.idDossier, queryParams).subscribe((data) => {
        this.isSelectedAll = false;
        this.checkTransactionsList =  data.content;
        this.total = data.totalElements;
        this.scrollRun();
      });
    } else {
      this.service.getCheckTransactions(queryParams).subscribe((data) => {
        this.isSelectedAll = false;
        this.checkTransactionsList = data.content;
        this.total = data.totalElements;
        this.scrollRun();
      });
    }
  }

  openDossierRoot(id: string): string {
    return `dossier/${id}/svedClient`;
  }

  /**
   * Метод открытия формы транзакции
   * id - уникальный идентификатор транзакции
   * transaction -> id
   */
  openTransactionForm(id: string): void {
    // @ts-ignore
    this.router.navigate([`clientTransactionForm/${id}`, {whereOpenUrl: "/cabinet/check-transactions".replaceAll('\/', '%2F')}]);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  getFilterObject(data: CheckTransactionsFilter): object {
    const filter = this.tableService.getFilterSubject(data) as CheckTransactionsFilter;
    return this.getFilterPlanObject(filter);
  }

  // @overwrite метод кастомной обработки плоского объекта фильтра
  // содержащего параметры запроса в виде объекта
  protected customPatchPlanObject(result, filter, key): void {
    // обработка случая для справочника валют
    if (key === 'currency' && filter[key]) {
      result[key] = filter[key].code;
    }
  }

  /**
   * Метод открытия формы проверки операции
   * id - уникальный идентификатор операции
   */
  viewForm(id: string): void {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(["checkTransactionForm", id]);
  }

  onSwitchResult(value: boolean): void {
    if (this.getFocusRowId()) {
      this.tableService.clear();
    }
    this.storeService.save(this.keyFilterResult, value);
    this.filter.result = value;
    this.onPageChange(this.getParams(this.filter) as CheckTransactionsFilter);
  }

  ngOnDestroy(): void {
    this.checkScrollOptions();
  }

  setAlertPanel(alertObjToSave: AlertPanelComponent): void {
  }

  exportExcelHandler(): void {
    const selected = this.getSelectedModel(this.checkTransactionsList) as Array<CheckTransactionInfo>;
    if (selected.length == 0 && this.total > this.MAX_EXPORTS_CHECKS) {
      const modal = this.modalService.open(ConfirmComponent);
      modal.componentInstance.text =
        'Результаты поиска превышают допустимое количество записей для выгрузки. \n' +
        `В случае продолжения в файл будут выгружены первые ${this.MAX_EXPORTS_CHECKS} найденных записей.`;
      modal.result.then(() => {
        this.exportExcelFile()
      }, () => {})
      return;
    }
    this.exportExcelFile(selected);
  }

  /**
   * Экспорт в EXCEL
   */
  public exportExcelFile(selected?: Array<CheckTransactionInfo>) {
    const successStatusId = 4;
    this.loadingExcelFile = true;
    this.getExportMethod(selected).subscribe(data => {
      if (data.type === successStatusId) {
        this.loadingExcelFile = false;
        saveAs(data.body, Utils.getFileNameFromContentDisposition(data));
      }
    }, (error) => {
      console.warn(error);
      this.loadingExcelFile = false;
    });
  }


  /**
   * Формирование отчета
   */
  public exportReport() {
    const modal = this.modalService.open(CheckTransactionDayReportComponent);
    modal.componentInstance.onSave.subscribe(data => this.downloadDayReport(data));
    return;
  }

  private getExportMethod(selected?: Array<CheckTransactionInfo>): Observable<any>{
    if(selected?.length>0){
      const ids = selected.map(s => s.id);
      return this.service.exportCheckTransactionListExcel(ids);
    } else {
      const filter = this.getFilterObject(this.filter);
      const queryParams = this.getParamsv2({...this.params, ...filter});
      queryParams["size"] = this.MAX_EXPORTS_CHECKS;
      const resultValue = this.storeService.get(this.keyFilterResult);
      if (typeof resultValue === "boolean") {
        queryParams["result"] = !resultValue;
      }
      return this.service.exportCheckTransactionsExcel(queryParams, this.idDossier);
    }
  }

  /**
   * Сформировать ФЭС
   */
  public generateFes() {
    const ids = (this.getSelectedModel(this.checkTransactionsList) as Array<CheckTransactionInfo>).map(s => s.id);
    const modalRef = this.modalService.open(GenerateFesComponent,  this._MODAL_CONFIG2);
    modalRef.componentInstance.open(ids);
    modalRef.result.then((data) => {
      this.onPageChange(this.getParams(this.filter) as CheckTransactionsFilter);
      this.isSelectedAll = false;
    });
  }
  /**
   * Отклонить код
   */
  public rejectCode() {
    this.service.getRejectReason().then((rejectReason: string) => {
      const ids = (this.getSelectedModel(this.checkTransactionsList) as Array<CheckTransactionInfo>).map(s => s.id);
      let rejectInfo: CheckTransactionRejectInfo = {
        ids: ids,
        rejectReason: rejectReason
      }
      this.service.rejectCodeByIdList(rejectInfo).subscribe((rejectResult: CheckTransactionRejectResult) => {
        if(!rejectResult.errors || !rejectResult.errors.size){
          this.alertObjToSave.open(this.alertPanelSrv.getSuccessMsg("Код успешно отклонен"));
        } else {
          const modalRef = this.modalService.open(CheckTransactionRejectResultComponent,  this._MODAL_CONFIG2);
          modalRef.componentInstance.data = rejectResult;
        }
        this.onPageChange(this.getParams(this.filter) as CheckTransactionsFilter);
        this.isSelectedAll = false;
      });
    });
  }

  getCheckCodeName(code: string): string {
    return this.dictSrv.getDictNameByCode(code, this.qrefVo4936);
  }

  getUnusualCodeName(code: string): string {
    return this.dictSrv.getDictNameByCode(code, this.list5599u, 'briefdesc');
  }

  private getCheckTransactionSelected(): CheckTransactionInfo[] {
    return this.getSelectedModel(this.checkTransactionsList) as CheckTransactionInfo[];
  }

  /**
   * Проверка, что выбраны только результаты проверки с одинаковым основным кодом и без дополнительных
   */
  checkOneCodeSelected(): boolean {
    const selected: CheckTransactionInfo[] = this.getCheckTransactionSelected();
    if(selected.length == 0){
      return false;
    }
    const basicCode = selected[0].basicCode;
    if(!basicCode) {
      return false;
    }
    return selected.every(s => !(s.otherCodes?.length > 0) && s.basicCode == basicCode)
  }

  /**
   * Проверка, что выбраны только результаты проверки с заполненным основным кодом
   */
  checkCanGenerateFes(): boolean {
    const selected: CheckTransactionInfo[] = this.getCheckTransactionSelected();
    if(selected.length == 0){
      return false;
    }
    return selected.every(s => s.basicCode != null)
  }

  editBlocked(row: CheckTransactionInfo): boolean {
    return row.transaction.payer.clientNeedProcessDmdk || row.transaction.recipient.clientNeedProcessDmdk
      || row.transaction.state != 'PROCESSED';
  }

  onRowClick(check: CheckTransactionInfo) {
    if(!this.editBlocked(check)) {
      this.viewForm(check.id);
      this.saveRowId(check.id);
    }
  }

  toDmdkTransactionsList(c: TransactionSubject) {
    this.router.navigate([`dossier/${c.clientRegistry}/clients-transactions`],
      {queryParams: {q: Utils.encodeJSONBase64({needProcessDmdk: true})} as Params});
  }

  getRowTitle(check: CheckTransactionInfo) {
    return check.transaction.state == 'RECHECK' ? "Требуется дополнительная проверка операции" : "";
  }

  private downloadDayReport(data: CheckDayReportParamsModel) {
    this.loadingReportFile = true;
    this.service.dowloadDayReport(data).pipe(finalize(() => this.loadingReportFile = false)).subscribe(data => {
      if (data.type === 4) {
        this.fSaver.save(data.body, Utils.getFileNameFromContentDisposition(data));
      }
    });
  }
}
